module.exports = __webpack_public_path__ + "img/img_i_coun_02.1e1bce49.png";